import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'font-awesome/css/font-awesome.css'
import './assets/css/main.css'
import { currency } from './commons/currency'
import { display_date, order_status, order_status_color, order_status_text_color, vip_level, vip_level_color, capitalize, display_value, display_color, display_text_color } from './commons/formater'
import VueResource from 'vue-resource'
import vuetify from './plugins/vuetify'
import VueMuuriGrid from 'vue-muuri-grid'
import HighchartsVue from 'highcharts-vue'
import firebase from 'firebase';
import { handleUnauthorizedResponse } from '@/commons/auth';

try {
  const firebaseConfig = {
    apiKey: 'AIzaSyAN2aQz5h9C_dGKNXkwYXx2xKmt4ON5FCM',
    authDomain: 'oee-app-cc5a1.firebaseapp.com',
    databaseURL: 'https://oee-app-cc5a1.firebaseio.com',
    projectId: 'oee-app-cc5a1',
    storageBucket: 'oee-app-cc5a1.appspot.com',
    messagingSenderId: '579480956217',
    appId: '1:579480956217:web:0e10030639ec0ab80ccce8',
    measurementId: 'G-54ZGV0VRV2'
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

} catch (error) {
  // expected output: ReferenceError: nonExistentFunction is not defined
  // Note - error messages will vary depending on browser
}

Vue.use(VueResource);
Vue.http.interceptors.push((request, next) => {
  next(response => {
    handleUnauthorizedResponse(response);
    return response;
  });
});
Vue.use(require('vue-shortkey'))
Vue.use(VueMuuriGrid);
import Highcharts from 'highcharts'
Highcharts.setOptions({
  lang: {
    numericSymbols: ['k', 'M', 'B', 'T', 'P', 'E']
  }
});
if (typeof window !== 'undefined' && window.Highcharts && window.Highcharts.setOptions) {
  window.Highcharts.setOptions({
    lang: {
      numericSymbols: ['k', 'M', 'B', 'T', 'P', 'E']
    }
  });
}
Vue.use(HighchartsVue);
Vue.filter('currency', currency)
Vue.filter('display_date', display_date)
Vue.filter('order_status', order_status)
Vue.filter('order_status_color', order_status_color)
Vue.filter('order_status_text_color', order_status_text_color)
Vue.filter('vip_level', vip_level)
Vue.filter('vip_level_color', vip_level_color)
Vue.filter('capitalize', capitalize)
Vue.filter('display_value', display_value)
Vue.filter('display_color', display_color)
Vue.filter('display_text_color', display_text_color)

import currencyInput from './components/general/CurrencyInput';
Vue.component('h-currency-input', currencyInput);
import widgetTemp from '@/components/dashboard/WidgetTemp';
Vue.component('widget-temp', widgetTemp);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
